<template>
  <div class="complaint">
    <Nav :title="title" :back="1"></Nav>
    <div class="content" :class="{ isIosx: isiOSX }">
      <h2 class="title" v-if="state == 0">投诉已提交</h2>
      <h2 class="title" v-if="state == 1">投诉处理中…</h2>
      <h2 class="title" v-if="state == 2">投诉已处理</h2>
      <h2 class="title" v-if="state == 3">投诉无效</h2>
      <p class="tip" v-if="state == 0">您的投诉已提交，请耐心等待处理</p>
      <p class="tip" v-if="state == 1">您提交的投诉正在处理中，请耐心等待</p>
      <p class="tip" v-if="state == 2">您提交的投诉已处理完成，感谢您的等待</p>
      <p class="tip" v-if="state == 3">您提交的投诉无效，请联系客服处理</p>
      <div class="step">
        <div class="step1 activestep">
          <span class="iconleft"></span><span>{{ data.created_at }}</span
          >已提交投诉
          <div class="line" v-if="state == 0"></div>
          <div class="line solidline" v-else></div>
        </div>
        <div class="step1" v-if="state == 0">
          <span class="iconleft"></span><span>等待客服处理中…</span>
        </div>

        <div class="step1 activestep" v-if="state != 0">
          <span class="iconleft"></span
          ><span v-if="state == 1">客服处理中…</span
          ><span v-if="state != 1">客服已处理…</span>
          <div class="line" v-if="state == 1"></div>
          <div class="line solidline" v-else></div>
        </div>
        <div class="step1" v-if="state == 1">
          <span class="iconleft"></span
          ><span>客服处理之后，投诉结果会展示在这里</span>
        </div>
        <div class="step1 activestep" v-if="state == 2">
          <span class="iconleft"></span><span>{{ data.updated_at }}</span
          >投诉成功
        </div>
        <div class="step1 invalidstep" v-if="state == 3">
          <span class="iconleft"></span><span>{{ data.updated_at }}</span
          >投诉无效
        </div>
      </div>
      <div class="steptip" v-if="state == 2 || state == 3">
        <p>客服处理文案：</p>
        <span v-if="state == 2"
          >经过核查，您的投诉成立，稍后将退至您的付款账户。</span
        >
        <span v-if="state == 3">经过核查，您的投诉无效。</span>
      </div>
      <div class="refundtip" v-if="state == 2">
        <p v-if="data.refund_coin!='0.00'">
          退红包：<span>{{ data.refund_coin }}</span>
        </p>
         <p v-if="data.refund_balance!='0.00'">
          退个人余额：<span>¥ {{ data.refund_balance }}</span>
        </p>
        <p>
          退款金额：<span>¥ {{ data.refund_money }}</span>
        </p>
      </div>
    </div>
    <div class="btn" v-if="state != 3">
      <van-button size="large" color="#181818" @click="goBack()"
        >返回</van-button
      >
    </div>
    <div class="invalidbtn" v-if="state == 3">
      <button class="left" @click="goBack()">返回</button>
      <a
        :href="'tel:' + data.service_phone"
        @click="iOStel(data.service_phone)"
        class="right"
      >
        <button>呼叫客服</button>
      </a>
    </div>
  </div>
</template>

<script>
import Nav from "./nav";
export default {
  data() {
    return {
      title: "投诉详情",
      isiOSX: false,
      state: 0,
      id: null,
      data: {},
    };
  },
  components: { Nav },
  created() {
    this.$api.setToken(this.$route.query.token);
    this.isiOSX = this.isIphoneX();
    this.id = this.$route.query.id || null;
    this.getComplaintData();
  },
  methods: {
    goBack() {
      this.params("", "", "goBack");
    },
    iOStel(phoneString) {
      // console.log(phoneString);
      let ua = navigator.userAgent.toLowerCase();
      if (/iphone|ipad|ipod|macintosh/i.test(ua) && !this.$route.query.from) {
        this.phone(phoneString);
      }
    },
    phone(phoneString) {
      this.tel = phoneString;
      this.params(this.tel, this.tel, "phone");
    },
    getComplaintData() {
      this.$api
        .post("/taxis/member/order/complaint/status", {
          id: this.id,
        })
        .then((res) => {
          console.log(res);
          this.data = res;
          if (res.status == 10) {
            this.state = 0;
          } else if (res.status == 20 || res.status == 30 || res.status == 40) {
            this.state = 1;
          } else if (res.status == 50) {
            this.state = 2;
          } else if (res.status == 60) {
            this.state = 3;
          }
        });
    },
  },
  mounted() {},
};
</script>

<style lang="less">
.complaint {
  background: #ffffff;
  .content {
    margin: 70px 15px 0;
    padding-top: 15px;
    .title {
      color: #333333;
      font-size: 20px;
      line-height: 28px;
      margin: 20px 0 5px;
    }
    .tip {
      color: #999999;
      font-size: 14px;
      line-height: 20px;
    }
    .step {
      //   border: 1px solid red;
      margin-top: 50px;

      .step1 {
        color: #999999;
        font-size: 16px;
        line-height: 22px;
        margin-bottom: 28px;
        position: relative;
        font-weight: bolder;
        span {
          margin: 0 10px 0 0;
        }
        .iconleft {
          display: inline-block;
          transform: translateY(2px);
          width: 13px;
          height: 13px;
          // border: 1px solid green;
          margin: 0 10px 0 0;
          background: url(./../../assets/takingCar/step2.png) no-repeat center
            center;
          background-size: cover;
        }
        .line {
          position: absolute;
          top: 22px;
          left: 6px;
          width: 1px;
          height: 27px;
          background: url(./../../assets/takingCar/dashes.png) no-repeat center
            center;
          background-size: cover;
        }
        .solidline {
          background: url(./../../assets/takingCar/solid.png) no-repeat center
            center;
          background-size: cover;
        }
      }
      .activestep {
        color: #333333;
        .iconleft {
          background: url(./../../assets/takingCar/qsd.png) no-repeat center
            center;
          background-size: cover;
        }
      }
      .invalidstep {
        color: #333333;
        .iconleft {
          background: url(./../../assets/takingCar/zd.png) no-repeat center
            center;
          background-size: cover;
        }
      }
    }
    .steptip {
      margin-top: 40px;
      p {
        color: #333333;
        font-size: 15px;
        line-height: 21px;
        margin-bottom: 5px;
      }
      span {
        display: block;
        color: #999999;
        font-size: 14px;
        line-height: 20px;
      }
    }
    .refundtip {
      border-top: 1px solid #eeeeee;
      margin-top: 15px;
      padding-top: 15px;
      color: #333333;
      font-size: 15px;
      line-height: 21px;
      span {
        color: #181818;
        font-size: 20px;
        line-height: 20px;
      }
    }
  }
  .btn {
    margin: 100px 20px 0;
  }
  .invalidbtn {
    height: 120px;
    background: #ffffff;
    // box-shadow: 1px 1px 6px #181818;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    button {
      height: 50px;
      border-radius: 5px;
      font-size: 18px;
      line-height: 25px;
    }
    .left {
      width: 42%;
      background-color: #ffffff;
      color: #333333;
      border: 1px solid #333333;
      margin-left: 20px;
    }
    .right {
      width: 42%;
      margin-right: 20px;
      button {
        background: #181818;
        color: #ffffff;
        border: none;
        width: 100%;
      }
    }
  }
  .isIosx {
    margin: 90px 15px 0;
  }
}
</style>
